import i18next, { type InitOptions, type Resource, type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import { locales, WaterlyLocale } from "@waterly/locales";

const defaultNamespaces = Object.keys(locales[WaterlyLocale.enUS]);
const localeList = Object.keys(locales) as WaterlyLocale[];

export interface CreateWaterlyI18nInstanceOptions {
  locale?: WaterlyLocale;
  supportedLocales?: WaterlyLocale[];
  namespaces?: string[];
  initOptions?: InitOptions;
}

export const createWaterlyI18nInstance = ({
  locale = WaterlyLocale.enUS,
  supportedLocales = localeList,
  namespaces = defaultNamespaces,
  initOptions,
}: CreateWaterlyI18nInstanceOptions = {}): I18nInstance => {
  const instance = i18next.createInstance();
  instance.use(initReactI18next);

  const resources = supportedLocales.reduce<Resource>((acc, supportedLocale) => {
    const namespaceMap = locales[supportedLocale];
    if (namespaceMap) {
      acc[supportedLocale] = namespaceMap;
    }
    return acc;
  }, {} as Resource);

  void instance.init({
    lng: locale,
    fallbackLng: WaterlyLocale.enUS,
    defaultNS: ["glossary", "common"],
    ns: namespaces,
    initImmediate: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    ...initOptions,
  });

  return instance;
};
